import { compareValueWithPrefix } from '@/helpers/compareValueWithPrefix'
import { AssignmentsRun, RunHistory, VehicleAssignmentsHistory } from '@/types/vehicleAllocation'

const parseBonnet = (value: string): [string, string] => {
    const clean = value.replace(/\s+/g, '')
    const match = clean.match(/^([A-Za-z]*)(\d+)$/)

    if (match) {
        const [, prefix, num] = match
        return [prefix, num]
    }

    return [clean, '0']
}

const sortRunHistory = (history: RunHistory[]): RunHistory[] =>
    history.sort((runA, runB) => {
        if (runA.bonnet === null) {
            return 1
        }

        if (runB.bonnet === null) {
            return -1
        }

        const a = parseBonnet(runA.bonnet)
        const b = parseBonnet(runB.bonnet)

        return compareValueWithPrefix(a, b)
    })

const sortRouteRuns = (runs: AssignmentsRun[]): AssignmentsRun[] =>
    runs.sort((runA, runB) => {
        // move nullable values to the end
        if (runA.run === null) {
            return 1
        }
        if (runB.run === null) {
            return -1
        }

        const [aPrefix, aNum] = runA.run
            .replace(/\s+/g, '')
            .match(/^([A-Za-z]*)(\d+)$/)!
            .slice(1)
        const [bPrefix, bNum] = runB.run
            .replace(/\s+/g, '')
            .match(/^([A-Za-z]*)(\d+)$/)!
            .slice(1)

        return compareValueWithPrefix([aPrefix, aNum], [bPrefix, bNum])
    })

export const sortVehicleAssignmentsHistory = (history: VehicleAssignmentsHistory[]): VehicleAssignmentsHistory[] => {
    const sortedHistory = history.sort((historyA, historyB) => {
        const [aPrefix, aNum] = (historyA.route.match(/^([A-Za-z]*)(\d+)$/)! || []).slice(1)
        const [bPrefix, bNum] = (historyB.route.match(/^([A-Za-z]*)(\d+)$/)! || []).slice(1)

        return compareValueWithPrefix([aPrefix || '', aNum], [bPrefix, bNum])
    })

    sortedHistory.forEach((item) => {
        item.runs = sortRouteRuns(item.runs)
        item.runs.forEach((run) => {
            run.history = sortRunHistory(run.history)
        })
    })

    return sortedHistory
}
